const { instance } = require("../Settings/instance");

export const environmetService = (success, error) => {
    instance.get('/environment').then((res) => {
        success(res);
      }).catch((err) => {
        error(err);
      });
}